import { useInstantSearch } from 'react-instantsearch';

export default function useRedirectURL() {
  const { results } = useInstantSearch();
  const query = results?.query;

  const url = (results?.renderingContent as { redirect?: { url?: string } })
    ?.redirect?.url;

  if (url) {
    const constructedUrl = new URL(url, window.location.origin);
    if (query) {
      constructedUrl.searchParams.set('query', query);
    }

    return constructedUrl.href;
  }

  return null;
}
